import { Directive, ElementRef, Input, OnChanges, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appImgBase64]'
})
export class ImgBase64Directive implements OnChanges {
  @Input() src;
  @Output() imageLoaded = new EventEmitter();

  constructor(
    private ele: ElementRef,
  ) {
  }

  ngOnChanges() {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = () => {
      const canvas: any = document.createElement('CANVAS');
      const ctx = canvas.getContext('2d');
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(img, 0, 0);
      const dataURL = canvas.toDataURL();
      this.ele.nativeElement.setAttribute('src', dataURL);
      setTimeout(() => {
        this.imageLoaded.emit();
      });
    }
    img.src = this.src.includes('?ts') ? this.src : this.src += `?ts=${new Date().getTime()}`;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/directives/img-base64.directive.ts